module.exports = __webpack_public_path__ + "static/media/BalloonHead.7b83e9c0.jpeg";